// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    id: This.GoalSetting.Id;
    gs: This.GoalSetting;
    isHr: boolean;
    isEditMode: boolean;
    viewMode: This.GoalSettingViewMode;
    columnVisibility: This.GoalSettingGoalColumnVisibility;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingEdit',
    templateUrl: './GoalSettingEdit.html',
    styleUrls: ['./GoalSettingEdit.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingEdit extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingEdit';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_id = computed(() => LowgileDataUtil.coerceDataType(this.queryParams()?.id ?? undefined, 'This.GoalSetting.Id', false, true));
    var_gs = proxySignal<This.GoalSetting>(undefined as any);
    var_isHr = proxySignal<boolean>(undefined as any);
    var_isEditMode = proxySignal<boolean>(undefined as any);
    var_viewMode = proxySignal<This.GoalSettingViewMode>(undefined as any);
    var_columnVisibility = proxySignal<This.GoalSettingGoalColumnVisibility>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get id() { return component.var_id() },
                get gs() { return component.var_gs() },
                set gs(value: This.GoalSetting) { component.var_gs.set(value) },
                get isHr() { return component.var_isHr() },
                set isHr(value: boolean) { component.var_isHr.set(value) },
                get isEditMode() { return component.var_isEditMode() },
                set isEditMode(value: boolean) { component.var_isEditMode.set(value) },
                get viewMode() { return component.var_viewMode() },
                set viewMode(value: This.GoalSettingViewMode) { component.var_viewMode.set(value) },
                get columnVisibility() { return component.var_columnVisibility() },
                set columnVisibility(value: This.GoalSettingGoalColumnVisibility) { component.var_columnVisibility.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            if (!isVariablesInitialized) this.screen.gs = (undefined)
            if (!isVariablesInitialized) this.screen.isHr = (undefined)
            if (!isVariablesInitialized) this.screen.isEditMode = (false)
            if (!isVariablesInitialized) this.screen.viewMode = (new This.GoalSettingViewMode)
            if (!isVariablesInitialized) this.screen.columnVisibility = (undefined)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_DropdownBlock_76_selectionChange_updateColumnVisibility_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                await this.action_updateColumnVisibility($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_77_selectionChange_updateColumnVisibility_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                await this.action_updateColumnVisibility($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_83_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.setSelfReviewPending()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_81_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.setSelfReviewDone()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_80_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.setDraft()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_82_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.setGoalsSubmitted()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_72_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await This.GoalSetting.save(screen.gs, 'save')
                    screen.isEditMode = !screen.isEditMode
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_71_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.isEditMode = !screen.isEditMode
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            const result = await This.GoalSettingUtil.loadById(screen.id, undefined)
            screen.gs = result.gs
            screen.viewMode = new This.GoalSettingViewMode(result.viewModeId)
            screen.isHr = Sys.User.currentUser.hasRole(This.$Roles.Hr)
            await this.action_updateColumnVisibility($event)
        }
    }

    async action_updateColumnVisibility($event?: any) {
        const { app, screen, output } = this
        {
            screen.viewMode = new This.GoalSettingViewMode(screen.viewMode.id)
            screen.columnVisibility = screen.gs.getColumnVisibility(screen.viewMode)
        }
    }
}
